import { type CSSObject } from '@emotion/react';
import { alpha } from '@mui/material/styles';

import { useTheme } from '@doxyme/ui-foundation/theme';

type Return = Record<
  | 'container'
  | 'videoContainer'
  | 'videoInnerContainer'
  | 'noVideoContainer'
  | 'noVideoInnerContainer'
  | 'progress'
  | 'avatarContainer'
  | 'noVideoIcon',
  CSSObject
>;

export const useModalVideoPreviewStyles = (): Return => {
  const theme = useTheme();

  return {
    container: {
      width: '100%',
      height: '100%',
      position: 'relative',
    },
    videoContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 6,
      alignSelf: 'stretch',
      position: 'relative',
    },
    videoInnerContainer: {
      position: 'relative',
      borderRadius: theme.shape.radius8,
      overflow: 'hidden',
      border: `1px solid ${theme.videotile.border}`,
      width: '100%',
    },
    noVideoContainer: {
      display: 'flex',
      width: '100%',
      height: '100%',
      padding: theme.spacing('82px', 10, '69px', 10),
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: theme.videotile.noCamera,
      borderRadius: theme.shape.radius8,
      overflow: 'hidden',
    },
    noVideoInnerContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: theme.spacing(3),
      textAlign: 'center',
    },
    progress: {
      width: '100%',
      position: 'absolute',
      left: 0,
      bottom: 0,

      '& .MuiLinearProgress-root': {
        height: '8px',
        backgroundColor: theme.palette.primary.main,
      },
      '& .MuiLinearProgress-colorSecondary': {
        backgroundColor: theme.palette.primary.main,
      },
      '& .MuiLinearProgress-colorPrimary': {
        backgroundColor: alpha(theme.palette.background.paper, 0.12),
      },
    },
    avatarContainer: {
      position: 'relative',
    },
    noVideoIcon: {
      display: 'inline-flex',
      padding: 6,
      justifyContent: 'center',
      alignItems: 'center',
      gap: 10,
      borderRadius: theme.shape.radius100,
      border: `4px solid ${theme.videotile.noCamera}`,
      background: theme.palette.alert.negative[100],
    },
  };
};
